export function AuraBackground() {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] opacity-40">
        <div className="absolute inset-0 rounded-full bg-purple-400 blur-[128px]" />
      </div>
      <div className="absolute top-1/4 left-1/3 w-[600px] h-[600px] opacity-30">
        <div className="absolute inset-0 rounded-full bg-purple-300 blur-[96px]" />
      </div>
      <div className="absolute bottom-1/4 right-1/3 w-[500px] h-[500px] opacity-30">
        <div className="absolute inset-0 rounded-full bg-purple-500 blur-[80px]" />
      </div>
    </div>
  );
}